import { render, staticRenderFns } from "./IconColorSwatchSolid.vue?vue&type=template&id=603ad782"
import script from "./IconColorSwatchSolid.vue?vue&type=script&lang=js"
export * from "./IconColorSwatchSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports